<div class="border rounded-xl overflow-hidden">
  <div class="flex justify-between items-center px-4 py-3 border-b bg-gray-50">
    <p class="text-sm font-semibold text-gray-900">Charges</p>

    <button *ngIf="canManage" vs-button size="sm" appearance="outline" (click)="lineDialog.openDialog(null)">
      <vs-icon name="plus" class="mr-1"></vs-icon> Add Charge
    </button>
  </div>

  <ng-container *ngIf="lines$ | async as lines">
    <p *ngIf="!lines.length" class="px-4 py-6 text-sm text-gray-500 text-center">
      No charges have been added to this repair job yet.
    </p>

    <div *ngIf="lines.length" class="overflow-x-auto">
      <table class="w-full text-sm" data-testid="charges-table">
        <thead>
          <tr class="text-left text-xs text-gray-500 border-b">
            <th class="pl-4 pr-2 py-2 font-medium">Type</th>
            <th class="px-2 py-2 font-medium">Description</th>
            <th class="px-2 py-2 font-medium text-right">Qty</th>
            <th class="px-2 py-2 font-medium text-right">Requested</th>
            <th class="px-2 py-2 font-medium text-right">{{ config.charges.allowedColumn }}</th>
            <th class="px-2 py-2 font-medium text-right">Authorized</th>
            <th class="px-2 py-2 font-medium text-right" [class.pr-4]="!showActions()">Difference</th>
            <th *ngIf="showActions()" class="pl-2 pr-4 py-2"></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let line of lines" class="border-b last:border-b-0" [class.opacity-50]="line.deleted">
            <td class="pl-4 pr-2 py-2">
              <vs-badge theme="default">{{ line.category | titlecase }}</vs-badge>
            </td>
            <td class="px-2 py-2">
              <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
                <span class="break-words min-w-0">{{ line.description }}</span>
                <vs-badge *ngIf="onHold.has(line.id)" theme="warn" data-testid="line-on-hold">
                  {{ config.charges.holdBadge }}
                </vs-badge>
              </div>
            </td>
            <td class="px-2 py-2 text-right whitespace-nowrap">{{ line.quantity ?? '-' }} {{ unitLabel(line) }}</td>
            <td class="px-2 py-2 text-right whitespace-nowrap" data-testid="line-requested">
              {{ formatAmount(line.requestedAmount) }}
            </td>
            <td class="px-2 py-2 text-right whitespace-nowrap" data-testid="line-allowed">
              {{ formatAmount(line.allowedAmount) }}
              <span *ngIf="line.recommendationSource" class="block text-xs text-gray-500">
                {{ config.sources[line.recommendationSource] }}
              </span>
            </td>
            <td class="px-2 py-2 text-right whitespace-nowrap" data-testid="line-authorized">
              {{ formatAmount(line.authorizedAmount) }}
            </td>
            <td
              class="px-2 py-2 text-right whitespace-nowrap"
              [class.pr-4]="!showActions()"
              data-testid="line-difference"
            >
              {{ formatAmount(difference(line)) }}
            </td>

            <td *ngIf="showActions()" class="pl-2 pr-4 py-2">
              <div class="flex items-center justify-end gap-2">
                <button
                  *ngIf="canAdjust && !line.deleted"
                  vs-icon-button
                  appearance="clear"
                  rounded
                  [vsTooltip]="config.charges.adjust"
                  data-testid="line-adjust"
                  (click)="adjustDialog.openDialog(line)"
                >
                  <vs-icon class="text-lg" name="scales-02"></vs-icon>
                </button>
                <button
                  *ngIf="!canAdjust && canViewHistory && line.adjustmentVersion > 0"
                  vs-icon-button
                  appearance="clear"
                  rounded
                  [vsTooltip]="config.adjust.viewHistory"
                  data-testid="line-history"
                  (click)="adjustDialog.openDialog(line, true)"
                >
                  <vs-icon class="text-lg" name="clock"></vs-icon>
                </button>
                <ng-container *ngIf="canManage">
                  <button vs-icon-button appearance="clear" rounded (click)="lineDialog.openDialog(line)">
                    <vs-icon class="text-lg" name="edit-01"></vs-icon>
                  </button>
                  <button vs-icon-button appearance="clear" rounded (click)="removeDialog.open(line)">
                    <vs-icon class="text-lg" name="trash-01"></vs-icon>
                  </button>
                </ng-container>
              </div>
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr class="border-t bg-gray-50 font-medium" data-testid="charges-totals">
            <td class="pl-4 pr-2 py-2" colspan="3">Job total</td>
            <td class="px-2 py-2 text-right">{{ formatAmount(requestedTotal(lines)) }}</td>
            <td class="px-2 py-2"></td>
            <td class="px-2 py-2 text-right">{{ formatAmount(authorizedTotal(lines)) }}</td>
            <td class="px-2 py-2 text-right" [class.pr-4]="!showActions()">
              {{ formatAmount(requestedTotal(lines) - authorizedTotal(lines)) }}
            </td>
            <td *ngIf="showActions()" class="pl-2 pr-4 py-2"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </ng-container>

  <ws-claim-item-line-dialog #lineDialog [claim]="claim" [item]="item" (saved)="changed()"></ws-claim-item-line-dialog>
  <ws-claim-item-line-adjust-dialog
    #adjustDialog
    [claim]="claim"
    [item]="item"
    [units]="units"
    (saved)="refresh()"
  ></ws-claim-item-line-adjust-dialog>
  <ws-claim-item-line-remove-dialog
    #removeDialog
    [claim]="claim"
    [item]="item"
    (removed)="changed()"
  ></ws-claim-item-line-remove-dialog>
</div>
